import { FileText, X } from 'lucide-react'
import { formatSize } from '@/lib/upload'
import type { PendingFile } from './useUploads'
import styles from './AttachmentStrip.module.css'

/** Файлы, ожидающие отправки: превью картинок, карточки остальных, прогресс загрузки. */
export function AttachmentStrip({ items, onRemove, disabled = false }: { items: PendingFile[]; onRemove: (id: string) => void; disabled?: boolean }) {
  if (items.length === 0) return null
  return (
    <div className={styles.strip} aria-label="Файлы к отправке">
      {items.map((f) => (
        <div key={f.id} className={styles.item} data-error={f.error ? '' : undefined}>
          {f.preview ? f.file.type.startsWith('video/') ? <video src={f.preview} className={styles.preview} preload="metadata" muted playsInline controls aria-label={f.file.name} /> : <img src={f.preview} alt="" className={styles.preview} /> : <span className={styles.icon}><FileText size={32} /></span>}
          <span className={styles.name} data-tooltip={f.file.name}>{f.file.name}</span>
          <span className={styles.size}>{f.error ?? formatSize(f.file.size)}</span>
          {f.progress > 0 && f.progress < 1 ? <span className={styles.progress} style={{ width: `${Math.round(f.progress * 100)}%` }} /> : null}
          <button type="button" disabled={disabled} className={styles.remove} aria-label={`Убрать ${f.file.name}`} onClick={() => onRemove(f.id)}><X size={14} /></button>
        </div>
      ))}
    </div>
  )
}
